import { render, staticRenderFns } from "./OrganizationStepper.vue?vue&type=template&id=67871944&scoped=true&"
import script from "./OrganizationStepper.vue?vue&type=script&lang=js&"
export * from "./OrganizationStepper.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationStepper.vue?vue&type=style&index=0&id=67871944&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67871944",
  null
  
)

export default component.exports